// TEMPORARY pricing hide (2026-08-17, sales request) — mirrors the TrackingMCP treatment.
//
// Sales asked us to take PUBLIC price figures off the marketing surface while packaging is reworked
// across the family: a per-plan monthly figure reads as the whole cost even though lane volume, query
// volume and seats drive the real number, so prospects self-disqualified before ever talking to us.
// Public price figures are replaced with a "Contact sales" panel.
//
// This is a REVERSIBLE switch: flip to `true` to restore every public price figure (the /pricing
// tier cards and the vs-comparison price rows).
//
// Scope is PUBLIC surfaces only — the signed-in dashboard, welcome and checkout screens keep their
// figures, because a customer who is already inside needs to know what they pay.
export const SHOW_PUBLIC_PRICING = false
